import script from "./TimeTableTeamLabelComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./TimeTableTeamLabelComponent.vue?vue&type=script&setup=true&lang=js"

import "./TimeTableTeamLabelComponent.vue?vue&type=style&index=0&id=750ea4a6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-750ea4a6"]])

export default __exports__